import React, { useContext } from "react";
import Context from "../../Context/Context";
import { getCurrencySymbol } from "../../Utils/utils";

export const TripSummary = (props) => {
  let bookedContext = useContext(Context);
  const AdultFares = props.adultFare;
  const ChildFares = props.childFare;
  const InfantFares = props.infantFare;
  const BookingFares = props.bookingFare;
  const currency = getCurrencySymbol();
  const formatFareAmount = (amount) =>
    `${currency}${parseFloat(amount || 0).toFixed(2)}`;
  const renderFareLine = (key, label, amount) => (
    <div className="fare-content fare-summary-line" key={key}>
      <div className="fare-summary-label">{label}</div>
      <div className="fare-summary-amount">{formatFareAmount(amount)}</div>
    </div>
  );

  return !props.pricingInfo ? (
    <React.Fragment>
      <div className="card text-primary trip-summary-card">
        <div className="card-header trip-summary-card-header">
          <img src={`/assets/ficon/trip.png`} alt="trip" />
          Fare Summary
        </div>
        <div className="card-body">
          <div className="row">
            {AdultFares ? (
              <div className="col-12">
                <div className="font-weight-bold fare-title">
                  {" "}
                  Fare for {AdultFares?.FARE?.No || ""} Adult
                  {AdultFares?.FARE?.No > 1 ? "s" : ""}{" "}
                </div>
                <div>
                  <div>
                    {Object.entries(AdultFares).map(([key, item]) => (
                      <React.Fragment key={`adult-${key}`}>
                        {renderFareLine(
                          `adult-ticket-${key}`,
                          <span>
                            {item.Item}{" "}
                            {(item.Item || "").includes("Ticket") ? (
                              <span className="tax">(Inc. Fees and Tax)</span>
                            ) : (
                              ""
                            )}
                          </span>,
                          item.Total,
                        )}
                        {props?.addBaggage
                          ? renderFareLine(
                              `adult-baggage-${key}`,
                              <span>
                                {AdultFares?.FARE?.No} x Adult Baggage{" "}
                                <span className="tax">
                                  {currency}
                                  {`(${props?.baggageBasePrice})`}
                                </span>
                              </span>,
                              props?.baggageBasePrice * AdultFares?.FARE?.No,
                            )
                          : null}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {ChildFares && ChildFares.FARE ? (
              <div className="col-12">
                <div className="font-weight-bold fare-title">
                  {" "}
                  Fare for {ChildFares?.FARE?.No || ""} Child
                  {ChildFares?.FARE?.No > 1 ? "ren" : ""}{" "}
                </div>
                <div>
                  <div>
                    {Object.entries(ChildFares).map(([key, item]) => (
                      <React.Fragment key={`child-${key}`}>
                        {renderFareLine(
                          `child-ticket-${key}`,
                          <span>
                            {item.Item}{" "}
                            {(item.Item || "").includes("Ticket") ? (
                              <span className="tax">(Inc. Fees and Tax)</span>
                            ) : (
                              ""
                            )}
                          </span>,
                          item.Total,
                        )}
                        {props?.addBaggage
                          ? renderFareLine(
                              `child-baggage-${key}`,
                              <span>
                                {ChildFares?.FARE?.No} x Child Baggage{" "}
                                <span className="tax">
                                  {currency}
                                  {`(${props?.baggageBasePrice})`}
                                </span>
                              </span>,
                              props?.baggageBasePrice * ChildFares?.FARE?.No,
                            )
                          : null}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {InfantFares && InfantFares.FARE ? (
              <div className="col-12">
                <div className="font-weight-bold fare-title">
                  {" "}
                  Fare for {InfantFares?.FARE?.No || ""} Infant
                  {InfantFares?.FARE?.No > 1 ? "s" : ""}{" "}
                </div>
                <div>
                  <div>
                    {Object.entries(InfantFares).map(([key, item]) => (
                      <React.Fragment key={`infant-${key}`}>
                        {renderFareLine(
                          `infant-ticket-${key}`,
                          <span>{item.Item}</span>,
                          item.Total,
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {BookingFares && BookingFares.FEE ? (
              <div className="col-12">
                <div className="font-weight-bold fare-title"> Other Fares </div>
                <div>
                  <div>
                    {Object.entries(BookingFares).map(([key, item]) => (
                      <React.Fragment key={`booking-${key}`}>
                        {renderFareLine(
                          `booking-fare-${key}`,
                          <span>{item.Item}</span>,
                          item.Total,
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <hr className="hr_divider" />

          {props?.taxPrice ? (
            <div className="font-weight-bold fare-title fees-tax-price fare-summary-line">
              <div className="fare-summary-label">Fees and Tax</div>
              <div className="tax-price-icard fare-summary-amount">
                {formatFareAmount(props.taxPrice)}
              </div>
            </div>
          ) : (
            ""
          )}

          {props?.bundleType != "" ? (
            <div className="font-weight-bold fare-title fees-tax-price fare-summary-line">
              <div className="fare-summary-label">{props.bundleType}</div>
              <div className="tax-price-icard fare-summary-amount">
                {formatFareAmount(props.cancellationPrice)}
              </div>
            </div>
          ) : (
            ""
          )}
          <div
            className="total-fare fare-summary-total"
            data-bind="with: ItinTotalFare[0].TotalFare"
          >
            <div className="fare-summary-label">Total Fare</div>
            <div className="fare-summary-total-amount">
              <h3 className="font-weight-bold">
                {formatFareAmount(
                  parseFloat(props.totalPrice) +
                    props.taxPrice +
                    props.baggagePrice +
                    props.cancellationPrice,
                )}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <div className="card text-primary trip-summary-card">
        <div className="card-header trip-summary-card-header">
          <img src={`/assets/ficon/trip.png`} alt="trip" />
          Fare Summary
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-12">
              <div>
                {props.pricingInfo.map((item) => (
                  <React.Fragment key={item.Item}>
                    {renderFareLine(
                      `pricing-${item.Item}`,
                      <span>{item.Item}</span>,
                      item.Total,
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
          <hr className="hr_divider" />
          <div
            className="total-fare fare-summary-total"
            data-bind="with: ItinTotalFare[0].TotalFare"
          >
            <div className="fare-summary-label">Total Fare</div>
            <div className="fare-summary-total-amount">
              <h3 className="font-weight-bold">
                {formatFareAmount(
                  props?.totalPrice
                    ? parseFloat(props?.totalPrice) + props.taxPrice
                    : bookedContext?.bookedFlightDetail?.data?.length &&
                      bookedContext?.bookedFlightDetail?.data[0]?.totalFare
                        ?.amount
                    ? parseFloat(
                        bookedContext?.bookedFlightDetail?.data[0]?.totalFare
                          ?.amount,
                      ) +
                      props.taxPrice +
                      props.baggagePrice
                    : 0,
                )}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
